/* file-autogenerated by @takeda-digital/xr on 2024-06-10 at 17:27:55.990 UTC */
export const projectVersion = "1716312877151" as const;
export const projectTitle = "Experience BioLife Plasma" as const;
export const projectDescription = "Start Your Tour" as const;
export const siteTheme = "#293375" as const;
